import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { DisplayText, Heading } from '@shopify/polaris';
import round from "lodash/round";

const propTypes = {
  transfer: PropTypes.object.isRequired,
  forForm: PropTypes.bool,
}

const defaultProps = {
  forForm: false
}


const TransferItemFooter = ({ transfer, forForm, ...props }) => {
  
  if(forForm){
    let totalQuantity = 0;
    let totalWithoutTax = 0;
    let totalWithTax = 0;
    // Format for new/edit form
    for(let pt of transfer.products_transfers_attributes){
      const itemTotalWithoutTax = Number(pt.unit_cost) * Number(pt.quantity);
      const itemTotalTax = (itemTotalWithoutTax * Number(pt.tax_rate) )/100;

      totalQuantity = Number(pt.quantity) + totalQuantity;
      totalWithoutTax = totalWithoutTax + itemTotalWithoutTax;
      totalWithTax = totalWithTax + round(itemTotalWithoutTax + itemTotalTax, 2);
    }
    return(
      <div className="row">
        <div className="col-md-1"></div>
          <div className="col-md-3 bg-black-0 white pv10">
            <DisplayText size="small">
              Total:
            </DisplayText>
          </div>
          <div className="col-md-2 bg-black-0 white pv10">
            <DisplayText size="small">
              { totalQuantity }
            </DisplayText>
          </div>
        <div className="col-md-3 bg-black-0 white pv10">
          <DisplayText size="small">
            { transfer.currency_symbol } { round(totalWithoutTax,2) }
          </DisplayText>
        </div>
        <div className="col-md-3 bg-black-0 white pv10">
          <DisplayText size="small">
            { transfer.currency_symbol } { round(totalWithTax,2) }
          </DisplayText>
        </div>
      </div>
    )
  }
  else{
    return(
      <div className="row">
        <div className="col-md-2"></div>
        <div className="col-md-2"></div>
        <div className="col-md-1"></div>

        <div className="col-md-2 bg-black-0 white pv10">
          <Heading>
            Total:
          </Heading>
        </div>
        <div className="col-md-3 bg-black-0 white pv10">
          <p className="fs16">
            { transfer.subtotal }
          </p>
        </div>
        <div className="col-md-2 bg-black-0 white pv10">
          <p className="fs16">
            { transfer.total_price_money }
          </p>
        </div>
      </div>
    )
  }    
};

TransferItemFooter.propTypes = propTypes;
TransferItemFooter.defaultProps = defaultProps;

export default TransferItemFooter;
